import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import DataTable from "react-data-table-component";
import { Alert } from "react-bootstrap";
import MiniLoader from "../../../../../utilityComponents/MiniLoader";
import {
    cartCountUpdate,
    selectedScenarioUuidList,
    selectedScenarioNameList,
    setCurrentPageNumber,
} from "../../../../../actions/CM/cm_open_loop/fusionDataCarMakerCollection/addToCartFusionDataCollectionAction";
import {
    fetchFusionCarMakerListInfo,
    deleteScenario,
    addDataToApprovedBucket,
} from "../../../../../actions/CM/cm_open_loop/fusionDataCarMakerCollection/dropDownModalAction";
import ReactPaginate from "react-paginate";

function scenarioCollection(props) {
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    let baseUrl = "data:image/png;base64,";
    if (Object.keys(props.variationInfo).length !== 0) {
        if (Boolean(props.variationInfo.aws_enabled) === true) {
            baseUrl = "";
        }
    }
    const [pages, setpages] = useState()
    const handleApprove = (e, row) => {
        let payload = {
            name: row.name,
            delete_flag: "True",
        };
        props.addDataToApprovedBucket(payload);
        props.fetchFusionCarMakerListInfo({ pages: pages });
        // alert(props.currentPageNum)

    };
    const [isApproved, setIsApproved] = useState(false)
    useEffect(() => {
        if (isApproved) {
            props.fetchFusionCarMakerListInfo(
                { pages: pages });
            setIsApproved(false);
        }
    }, [isApproved]);



    function handleCloseErrorModal() {
        setShowErrorModal(false);
        setErrorMessage("");
    }

    const onSelectScenarioVariation = (e, row) => {
        if (props.variationUuidList.indexOf(row.scenario_uuid) !== -1) {
            props.selectedScenarioUuidList(props.variationUuidList);
            props.selectedScenarioNameList(props.variationNameList);
        } else {
            props.selectedScenarioUuidList(props.variationUuidList.concat(row.uuid));
            props.selectedScenarioNameList(props.variationNameList.concat(row.name));
        }
    };

    function onDeselectScenarioVariation(e, row) {
        props.selectedScenarioUuidList(
            props.variationUuidList.filter((i) => i !== row.uuid)
        );
        props.selectedScenarioNameList(
            props.variationNameList.filter((i) => i !== row.name)
        );
    }

    function cartUpdate() {
        if (props.variationInfo.data !== undefined) {
            if (Object.keys(props.variationInfo.data).length !== 0) {
                const obj = {
                    count: props.variationNameList.length,
                    items: props.variationNameList,
                };
                props.cartCountUpdate(obj);
            } else {
                const obj = {
                    count: 0,
                    items: [],
                };
                props.cartCountUpdate(obj);
            }
        } else {
            const obj = {
                count: 0,
                items: [],
            };
            props.cartCountUpdate(obj);
        }
    }

    useEffect(() => {
        cartUpdate();
    }, [props.variationNameList]);

    const columns = [
        {
            name: "Scenario Name",
            selector: "scenarioVariationName",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.name}</div>,
        },
        {
            name: "Scenario Description",
            selector: "scenarioVariationDiscription",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.description}</div>,
            grow: 3,
        },
        {
            name: "Scenario UUID",
            selector: "scenarioVersion",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.uuid}</div>,
        },

        {
            name: "Updated At",
            selector: "scenarioVariationUuid",
            sortable: true,
            cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.updated_at}</div>,
        },
        {
            name: "Status",
            selector: "Status",
            sortable: true,
            cell: (row) => (
                <div style={{ flexWrap: "wrap" }}>
                    {row.status === "bad" ? null : (
                        <button
                            onClick={(e) => handleApprove(e, row)}
                            disabled={row.status == "good" ? false : true}
                            style={{
                                backgroundColor: row.status === "good" ? "lightyellow" : "lightgreen",
                                color: "black",
                                padding: "8px 16px",
                                border: "none",
                                borderRadius: "10px",
                                cursor: row.status === "good" ? "pointer" : "not-allowed"
                            }}
                        >
                            {row.status == "good" ? "Approve" : "Approved"}
                        </button>
                    )}
                </div>
            ),
        },
        {
            name: "Actions",
            selector: "actions",
            sortable: true,
            cell: (row) => (
                <div style={{ flexWrap: "wrap" }}>
                    {row.status == "approved" && (
                        <div
                            style={{
                                display: "inline-block",
                                margin: "0.5rem",
                                fontSize: "1.5rem",
                            }}
                        >
                            {props.variationUuidList.includes(row.scenario_uuid) ? (
                                <button
                                    style={
                                        Object.keys(props.scenarioObjectListData).length !== 0
                                            ? { backgroundColor: "#a8abf7" }
                                            : { backgroundColor: "#757AF7" }
                                    }
                                    onClick={(e) => onDeselectScenarioVariation(e, row)}
                                    disabled={
                                        Object.keys(props.scenarioObjectListData).length !== 0
                                    }
                                >
                                    <i className="fas fa-check-square"></i>
                                </button>
                            ) : (
                                <button
                                    style={
                                        Object.keys(props.scenarioObjectListData).length !== 0
                                            ? { backgroundColor: "#a8abf7" }
                                            : { backgroundColor: "#757AF7" }
                                    }
                                    onClick={(e) => onSelectScenarioVariation(e, row)}
                                    disabled={
                                        Object.keys(props.scenarioObjectListData).length !== 0
                                    }
                                >
                                    <i className="fas fa-plus-square"></i>
                                </button>
                            )}
                        </div>
                    )}
                </div>
            ),
        },
    ];

    const customStyles = {
        rows: {
            style: {
                flexWrap: "nowrap",
                minHeight: "70px",
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "70px",
                display: "flex",
                backgroundColor: "white",
                padding: ".75rem",
                verticalAlign: "top",
                borderTop: "1px solid #e9ecef",
                borderBottom: "5px solid #757AF7",
                justifyContent: "center",
            },
        },
        cells: {
            style: {
                width: "200%",
                maxWidth: "70%",
                fontSize: "0.98rem",
                textAlign: "center",
                verticalAlign: "top",
                borderTop: "5px solid white",
                justifyContent: "center",
                borderBottom: "0",
            },
        },
    };

    const handlePageClick = (event) => {
        let currentPage = event.selected + 1;
        setpages(currentPage)
        props.setCurrentPageNumber(event.selected);
        props.fetchFusionCarMakerListInfo({ pages: currentPage })
    };


    return (
        <div className="col-lg-12" style={{ padding: "0 1rem" }}>
            <div
                style={{
                    padding: "0.5rem",
                    border: "0.2rem solid",
                    borderRadius: "0.5rem",
                }}
            >
                {props.loader ? (
                    <MiniLoader />
                ) : props.error ? (
                    <Alert key="danger" variant="danger">
                        {props.error}
                    </Alert>
                ) : (
                    <div className="col-lg-12">
                        {props.variationInfo.data ? (
                            props.variationInfo.data.length > 0 ? (
                                <div style={{ float: "right" }}>
                                </div>
                            ) : undefined
                        ) : undefined}

                        {props.variationInfo.data && (
                            <DataTable
                                className="dataTables_wrapper"
                                columns={columns}
                                // expandableRows
                                // expandableRowsComponent={<ExpandableComponent />}
                                customStyles={customStyles}
                                data={props.variationInfo.data}
                                defaultSortField="id"
                                defaultSortAsc={false}
                            />
                        )}
                    </div>
                )}
                {props.variationInfo.total_variation_count > 0 && (
                    <ReactPaginate
                        previousLabel="<<"
                        breakLabel="..."
                        nextLabel=">>"
                        onPageChange={handlePageClick}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        pageCount={props.variationInfo.pages}
                        containerClassName={"pagination justify-content-center"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={props.currentPageNum}
                    />
                )}
                {/* Error modal */}
                {showErrorModal && (
                    <div
                        className="modal"
                        tabIndex="-1"
                        role="dialog"
                        style={{ display: "block" }}
                    >
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Error</h5>
                                    <button
                                        type="button"
                                        className="close"
                                        onClick={handleCloseErrorModal}
                                    >
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>{errorMessage}</p>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={handleCloseErrorModal}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    loader: state.DropDownSubmitReducer.loading,
    error: state.DropDownSubmitReducer.error,
    variationInfo: state.DropDownSubmitCarMakerFusionReducer.variationListInfo,
    variationUuidList: state.selectedScenarioUuidListData.variationUuidList,
    variationNameList: state.selectedScenarioNameListData.variationNameList,
    scenarioObjectListData:
        state.addBulkScenariosToListStatus.selectedScenarioObjectList,
    currentPageNum: state.currentPageNumberData.currentPageNumber,
});

const mapDispatchToProps = (dispatch) => ({
    cartCountUpdate: (obj) => dispatch(cartCountUpdate(obj)),
    selectedScenarioUuidList: (variationUuid) =>
        dispatch(selectedScenarioUuidList(variationUuid)),
    selectedScenarioNameList: (variationName) =>
        dispatch(selectedScenarioNameList(variationName)),
    setCurrentPageNumber: (currentPageNumber) =>
        dispatch(setCurrentPageNumber(currentPageNumber)),
    fetchFusionCarMakerListInfo: (currentPageNumber) => dispatch(fetchFusionCarMakerListInfo(currentPageNumber)),
    deleteScenario: (scenarioUuid) => dispatch(deleteScenario(scenarioUuid)),
    addDataToApprovedBucket: (payload) =>
        dispatch(addDataToApprovedBucket(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(scenarioCollection);